<app-confirmation-modal>
  <ng-container subHeader>Are you sure you want to deny credentials?</ng-container>
  <ng-container content>Denying credentials will cancel the session.</ng-container>

  <ng-container actionButton>
    <app-button type="secondary" (buttonClick)="this.backToIdVerificationView()"> Go Back </app-button>
    <app-button type="warning" (buttonClick)="this.confirmDenial()"> Deny and Cancel Session </app-button>
  </ng-container>
</app-confirmation-modal>
